import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

import { getSize, getColor } from '@lib/common';
import { QuestionType, Size } from '../../../../../form';
import styled from '@xstyled/styled-components';
import { Button, Space, Tooltip } from 'antd';
import Image from 'next/image';
import { useMemo } from 'react';
import { useQuestionContext } from '../../core';
import { QuestionContextProvider } from '../../core/question.context';
import { QuestionAiChangeStrategyFactory } from './strategies';
import { AudioFileContainerDirection, AudioFilePreview } from '../../../audio-file';
import { getEditBadgeStyles } from '../../../shared';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledCard = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  ", "\n  border-radius: ", ";\n  padding: ", ";\n"])), function (props) {
  return getSize('padding20')(props);
}, function (_ref) {
  var $changeType = _ref.$changeType,
      theme = _ref.theme;

  var _getEditBadgeStyles = getEditBadgeStyles($changeType, theme),
      bg = _getEditBadgeStyles.bg,
      border = _getEditBadgeStyles.border;

  return "\n      background-color: ".concat(bg, ";\n      border: 2px dashed ").concat(border, ";\n    ");
}, function (props) {
  return getSize('radiusSm')(props);
}, function (props) {
  return getSize('padding24')(props);
});
var StyledTopBar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledTopLeft = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (props) {
  return getSize('padding8')(props);
});
var StyledEditBadge = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  font-size: ", ";\n  font-weight: 700;\n  border-radius: 9999px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex-shrink: 0;\n  ", "\n"])), function (props) {
  return getSize('typo14')(props);
}, function (_ref2) {
  var $changeType = _ref2.$changeType,
      theme = _ref2.theme;

  var _getEditBadgeStyles2 = getEditBadgeStyles($changeType, theme),
      color = _getEditBadgeStyles2.color,
      border = _getEditBadgeStyles2.border,
      badgeBgColor = _getEditBadgeStyles2.badgeBgColor;

  return "\n      background-color: ".concat(badgeBgColor, ";\n      color: ").concat(color, ";\n      border: 1px solid ").concat(border, ";\n    ");
});
var StyledTopActions = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (props) {
  return getSize('padding12')(props);
});
var StyledMentionButton = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #cbd5e1;\n    background: #f8fafc;\n  }\n"])));
var StyledRejectButton = styled(Button)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  color: #1e293b;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n\n  &:hover {\n    color: #1e293b !important;\n    border-color: #cbd5e1 !important;\n    background: #f8fafc !important;\n  }\n\n  svg {\n    font-size: 16px;\n  }\n"])));
var StyledAcceptButton = styled(Button)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background-color: #2563eb !important;\n  border-color: #166534 !important;\n  color: #ffffff !important;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  &:hover {\n    background-color: #1e40af !important;\n    border-color: #14532d !important;\n  }\n\n  svg {\n    font-size: 16px;\n  }\n"])));
var StyledMetaBar = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  gap: ", ";\n"])), function (props) {
  return getSize('padding12')(props);
});
var StyledMetaRow = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (props) {
  return getSize('padding12')(props);
});
var StyledQuestionNumberTag = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n"])), getSize('padding2'), getSize('padding8'), getSize('typo12'), getSize('typo16'), getColor('fillIntActive'), getSize('radiusS'));
var StyledQuestionScoreTag = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: flex-start;\n  gap: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  background-color: #ffffff;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
var StyledQuestionTypeTag = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: flex-start;\n  gap: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  background-color: #ffffff;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
var StyledDescriptionWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: baseline;\n"])));
var StyledExplanationWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n  width: 100%;\n  padding: ", ";\n  background-color: #f8fafc;\n  border-radius: ", ";\n  border: 1px solid #e2e8f0;\n"])), function (props) {
  return getSize('padding4')(props);
}, function (props) {
  return getSize('padding12')(props);
}, function (props) {
  return getSize('radiusSm')(props);
});
var StyledExplanationIconWrapper = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  flex-shrink: 0;\n"])), function (props) {
  return getSize('padding24')(props);
}, function (props) {
  return getSize('padding24')(props);
});
var StyledExplanationContent = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  flex: 1;\n"])), function (props) {
  return getSize('padding4')(props);
});
var StyledExplanationTitle = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.5;\n"])), getSize('typo16'));

var BaseQuestionAiChangePreviewContent = function BaseQuestionAiChangePreviewContent(_ref3) {
  var _question$audioFile;

  var states = _ref3.states,
      actions = _ref3.actions,
      children = _ref3.children;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var labels = states.labels,
      before = states.before,
      after = states.after,
      changeType = states.changeType,
      icons = states.icons,
      isAccepting = states.isAccepting,
      strategyProp = states.strategy,
      customDescription = states.customDescription;
  var onAccept = actions.onAccept,
      onReject = actions.onReject,
      onMention = actions.onMention;
  var defaultStrategy = useMemo(function () {
    return QuestionAiChangeStrategyFactory.create({
      changeType: changeType,
      before: before,
      after: after,
      label: {
        badgeNew: labels.badgeNew,
        badgeEdit: labels.badgeEdit,
        badgeDelete: labels.badgeDelete
      }
    });
  }, [changeType, before, after, labels.badgeNew, labels.badgeEdit, labels.badgeDelete]);
  var strategy = strategyProp !== null && strategyProp !== void 0 ? strategyProp : defaultStrategy;
  var questionTypeTagLabelMapping = useMemo(function () {
    var _ref4;

    return _ref4 = {}, _defineProperty(_ref4, QuestionType.SingleChoice, labels.singleChoice), _defineProperty(_ref4, QuestionType.FillInBlank, labels.fillInBlank), _defineProperty(_ref4, QuestionType.Matching, labels.matching), _defineProperty(_ref4, QuestionType.Essay, labels.essay), _defineProperty(_ref4, QuestionType.MultipleChoice, labels.multipleChoice), _ref4;
  }, [labels]);
  var questionTypeTagLabel = questionTypeTagLabelMapping[question.type] || 'Unknown';
  var jsonAudioFile = question === null || question === void 0 ? void 0 : (_question$audioFile = question.audioFile) === null || _question$audioFile === void 0 ? void 0 : _question$audioFile.toJsonObject();
  return /*#__PURE__*/_jsxs(StyledCard, {
    $changeType: changeType,
    id: question.id.toString(),
    children: [/*#__PURE__*/_jsxs(StyledMetaBar, {
      children: [/*#__PURE__*/_jsx(StyledMetaRow, {
        children: /*#__PURE__*/_jsxs(Space, {
          size: 12,
          children: [/*#__PURE__*/_jsxs(StyledQuestionNumberTag, {
            children: [labels.question, " ", question.titleIndex]
          }), /*#__PURE__*/_jsxs(StyledQuestionScoreTag, {
            children: [icons.star, /*#__PURE__*/_jsxs("span", {
              children: [strategy.renderScore && strategy.renderScore(), " ", labels.score]
            })]
          }), /*#__PURE__*/_jsxs(StyledQuestionTypeTag, {
            children: [icons.pointFocus, /*#__PURE__*/_jsx("span", {
              children: questionTypeTagLabel
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(StyledMetaRow, {
        children: onMention && /*#__PURE__*/_jsx(Tooltip, {
          title: "Mention",
          placement: "bottom",
          children: /*#__PURE__*/_jsx(StyledMentionButton, {
            type: "button",
            onClick: function onClick(e) {
              e.stopPropagation();
              onMention();
            },
            children: /*#__PURE__*/_jsx(Image, {
              src: "/icons/ai.png",
              width: 16,
              height: 16,
              alt: "mention"
            })
          })
        })
      })]
    }), jsonAudioFile && /*#__PURE__*/_jsx(AudioFilePreview, {
      source: jsonAudioFile.url,
      fileName: jsonAudioFile.name,
      fileSize: Size.format(jsonAudioFile.size),
      direction: AudioFileContainerDirection.HORIZONTAL,
      shouldShowExtraInfo: false,
      isAllowedToReplay: true,
      disabled: false
    }), /*#__PURE__*/_jsx(StyledDescriptionWrapper, {
      children: customDescription ? customDescription : strategy.renderDescription && strategy.renderDescription()
    }), children, ((question === null || question === void 0 ? void 0 : question.explanation) || (before === null || before === void 0 ? void 0 : before.explanation)) && strategy.renderExplanation && /*#__PURE__*/_jsxs(StyledExplanationWrapper, {
      children: [/*#__PURE__*/_jsx(StyledExplanationIconWrapper, {
        children: icons.lightBulb
      }), /*#__PURE__*/_jsxs(StyledExplanationContent, {
        children: [/*#__PURE__*/_jsx(StyledExplanationTitle, {
          children: labels.explanation
        }), strategy.renderExplanation()]
      })]
    })]
  });
};

export var BaseQuestionAiChangePreviewComponent = function BaseQuestionAiChangePreviewComponent(_ref5) {
  var states = _ref5.states,
      actions = _ref5.actions,
      children = _ref5.children;
  return /*#__PURE__*/_jsx(QuestionContextProvider, {
    question: states.after,
    children: /*#__PURE__*/_jsx(BaseQuestionAiChangePreviewContent, {
      states: states,
      actions: actions,
      children: children
    })
  });
};